import axiosInstance from '../../main/axios';
import { toastr } from 'react-redux-toastr';
import { initialize } from 'redux-form';
import { showTabs, selectTab } from '../../common/tab/tabActions';

const INITIAL_VALUES = { ativo: '1', unidade: 'UN', quantidade_atual: 0, quantidade_minima: 0 };
const MOV_INITIAL = { tipo: 'ENTRADA' };

export { selectTab };

export function getList() {
  const request = axiosInstance.get('/manutencao/estoque');
  return {
    type: 'ESTOQUE_FETCHED',
    payload: request,
  };
}

export const setPaginaAtual = pagina => ({
  type: 'ESTOQUE_PAGE',
  payload: pagina,
});

function normalize(values) {
  return {
    ...values,
    ativo: parseInt(values.ativo, 10) === 1,
    quantidade_atual: values.quantidade_atual ? parseFloat(values.quantidade_atual) : 0,
    quantidade_minima: values.quantidade_minima ? parseFloat(values.quantidade_minima) : 0,
  };
}

export function create(values) {
  return submit(normalize(values), 'post');
}

export function update(values) {
  return submit(normalize(values), 'put');
}

export function remove(values) {
  return dispatch => {
    axiosInstance
      .delete(`/manutencao/estoque/${values.id}`)
      .then(() => {
        toastr.success('Sucesso', 'Item removido com sucesso.');
        dispatch(init());
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível remover o item.');
      });
  };
}

export function movimentar(values) {
  return dispatch => {
    const payload = {
      ...values,
      quantidade: values.quantidade ? parseFloat(values.quantidade) : 0,
      estoque_item_id: values.estoque_item_id ? parseInt(values.estoque_item_id, 10) : null,
    };
    axiosInstance
      .post('/manutencao/estoque/movimentacao', payload)
      .then(() => {
        toastr.success('Sucesso', 'Movimentação registrada com sucesso.');
        dispatch(init());
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível registrar a movimentação.');
      });
  };
}

function submit(values, method) {
  return dispatch => {
    const id = values.id ? values.id : '';
    const url = method === 'put' ? `/manutencao/estoque/${id}` : '/manutencao/estoque';
    axiosInstance[method](url, values)
      .then(() => {
        toastr.success('Sucesso', 'Operação realizada com sucesso.');
        dispatch(init());
      })
      .catch(e => {
        const msg = e.response && e.response.data && e.response.data.message;
        toastr.error('Erro', msg || 'Não foi possível salvar o item.');
      });
  };
}

export function showUpdate(item) {
  return [
    showTabs('tabUpdate'),
    selectTab('tabUpdate'),
    initialize('estoqueForm', { ...item, ativo: item.ativo ? '1' : '0' }),
  ];
}

export function init() {
  return [
    showTabs('tabList', 'tabCreate', 'tabMov'),
    selectTab('tabList'),
    getList(),
    initialize('estoqueForm', INITIAL_VALUES),
    initialize('estoqueMovForm', MOV_INITIAL),
  ];
}
